import {
  getAuth,
  GoogleAuthProvider,
  FacebookAuthProvider,
  TwitterAuthProvider,
  OAuthProvider,
  signInWithPopup,
  signOut,
} from "firebase/auth";
import { useLocation, useNavigate } from "react-router-dom";
import useStore from "../Store/useStore";

const useLogins = () => {
  const auth = getAuth();
  const { setShowLogout, setNotify, setAuthLoading } = useStore();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  /* Common SignIn */
  const signIn = async (provider) => {
    try {
      setAuthLoading(true);
      await signInWithPopup(auth, provider);
    } catch (err) {
      setAuthLoading(false);
      setNotify({
        status: false,
        message: err?.message?.split("/")[1]?.split(")")[0],
      });
    }
  };

  /* Google SignIn */
  const googleSignIn = () => {
    const provider = new GoogleAuthProvider();
    signIn(provider);
  };

  /* Facebook SignIn */
  const facebookSignIn = () => {
    const provider = new FacebookAuthProvider();
    signIn(provider);
  };

  /* Facebook SignIn */
  const twitterSignIn = () => {
    const provider = new TwitterAuthProvider();
    signIn(provider);
  };

  /* Apple SignIn */
  const appleSignIn = () => {
    const provider = new OAuthProvider("apple.com");
    signIn(provider);
  };

  /* Signout */
  const signOutUser = () => {
    if (pathname.toLowerCase().includes("influencerslists")) {
      navigate("/");
    }
    signOut(auth)
      .then(() => {
        setShowLogout(false);
      })
      .catch(() => {});
  };

  /* Returned Items */
  return {
    googleSignIn,
    facebookSignIn,
    twitterSignIn,
    appleSignIn,
    signOutUser,
  };
};

export default useLogins;
